import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PricingSection } from '../components/PricingSection';
export function MembershipPage() {
  return <div className="bg-black text-white min-h-screen" data-id="element-347">
      <Header data-id="element-348" />
      <main className="pt-20" data-id="element-349">
        <div className="container mx-auto px-4 py-16" data-id="element-350">
          <h1 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-351">
            Membership Plans
          </h1>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl" data-id="element-352">
            Choose the membership plan that works best for you. Get unlimited
            access to all our classes and exclusive resources to accelerate your
            trading journey.
          </p>
        </div>
        <PricingSection data-id="element-353" />
      </main>
      <Footer data-id="element-354" />
    </div>;
}